import { queryOptions } from '@tanstack/react-query';

import { GlobalMarketEntity } from '@/entities';

const STALE_TIME = 1000 * 60 * 5; // 5분 (서버 갱신 주기와 동일)

export const options = {
  rootKey: 'global-market',
  getIndices: () =>
    queryOptions({
      queryKey: [options.rootKey, 'indices'],
      queryFn: () => GlobalMarketEntity.GlobalMarketRepository.getIndices(),
      staleTime: STALE_TIME,
      refetchInterval: STALE_TIME,
    }),
  getCommodities: () =>
    queryOptions({
      queryKey: [options.rootKey, 'commodities'],
      queryFn: () => GlobalMarketEntity.GlobalMarketRepository.getCommodities(),
      staleTime: STALE_TIME,
      refetchInterval: STALE_TIME,
    }),
};
